import styled from 'styled-components';

import { PULSE, PULSE_AHEAD, ACQ_MOBILE, type PulseAheadKind } from '../../../../theme/tokens';
import { hoverWash } from '../../../../theme/mixins';
import { Text } from '../../../../components';

/** Headline figure + its caption, inset 5px to align under the section title. */
export const Lead = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 0 5px;
`;

export const Value = styled.span`
  font-size: 24px;
  font-weight: 700;
  color: ${PULSE.t50};
  letter-spacing: -0.02em;
  line-height: 1.1;
  font-variant-numeric: tabular-nums;
`;

export const Sub = styled(Text)`
  display: block;
  font-size: 12px;
  color: ${PULSE.t500};
`;

/** Forecast rows sit side-by-side on desktop, stacking on mobile. */
export const Items = styled.div`
  display: flex;
  gap: 10px;

  ${ACQ_MOBILE} {
    flex-direction: column;
  }
`;

/** One forecast row, tinted green ("tailwind") or orange ("watch") by its radial
 *  glow — NO border (Figma). Clickable: carries the shared hover/focus wash. */
export const Item = styled.button<{ $kind: PulseAheadKind }>`
  ${hoverWash}
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  align-items: center;
  gap: 12px;
  padding: 12px;
  border: 0;
  border-radius: 16px;
  background: ${(p) => PULSE_AHEAD[p.$kind]};
  font: inherit;
  text-align: left;
  cursor: pointer;
`;

export const Spark = styled.img`
  width: 16px;
  height: 16px;
  display: block;
  flex-shrink: 0;
`;

export const Copy = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 0;
`;

export const Tag = styled(Text)`
  display: block;
  font-size: 16px;
  font-weight: 400;
  color: ${PULSE.t300};
`;

export const ItemText = styled(Text)`
  display: block;
  font-size: 14px;
  font-weight: 300;
  color: ${PULSE.t300};
`;

export const Chev = styled.span`
  margin-left: auto;
  color: ${PULSE.t300};
  display: flex;
  flex-shrink: 0;
`;

/** Muted placeholder where the tailwind / watch-out cards would sit — there is no
 *  source for the qualitative forecast copy yet. */
export const NotAvailable = styled(Text)`
  display: block;
  font-size: 14px;
  color: ${PULSE.t500};
  background: ${PULSE.panel};
  border-radius: 16px;
  padding: 16px;
`;
